import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-conciliacion-chart-item',
  templateUrl: './conciliacion-chart-item.component.html',
  styleUrls: ['./conciliacion-chart-item.component.scss'],
})

export class ConciliacionChartItemComponent implements OnInit  {

  @Input() title = "";
  @Input() data: any;

  constructor() {
  }

  ngOnInit() {

  }

  get leftCaption () {
    return this.data.left.caption ?
      this.data.left.caption : 'Ganalottodo';
  }

  get rightCaption () {
    return this.data.right.caption ?
      this.data.right.caption : 'Pronósticos';
  }
  get showBorders () {
    return _.isNil(this.data.hideDiff);
  }

  get isCounter() {
    return this.data.type === CONCILIACION_ITEM_TYPE.COUNTER ||
      this.data.left.affinity === 'counter' ||
      this.data.right.affinity === 'counter';
  }

  get isMoney() {
    return this.data.type === CONCILIACION_ITEM_TYPE.CURRENCY ||
      this.data.left.affinity === 'amount' ||
      this.data.right.affinity === 'amount';
  }

  get diferencia() {
    return this.data.hideDiff ?
      0 : this. isCounter ?
        this.data.right.counter - this.data.left.counter :
        this.data.right.amount - this.data.left.amount;
  }

}

export enum CONCILIACION_ITEM_TYPE {
  NONE = 0,
  COUNTER = 1,
  CURRENCY = 2
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/conciliacion/conciliacion-chart-item.component.ts